import { theme } from "../../theme";
export const genericFieldsView = {
    root: {
      width: "45%",
      height: "100%",
      backgroundColor: theme.palette.grey[600],
      overflow: "auto",
      borderRadius: "5px",
    },
    infoTitle: {
      backgroundColor: "#fff",
      display: "flex",
      padding: "20px",
    },
    infoFields: {
      padding: "20px",
      textAlign: "left",
    },
    avatar: {
      width: "50px",
      height: "50px",
      marginRight: "20px",
    },
  } as const;